import { render } from "./FileUploadConfig.vue?vue&type=template&id=5d3a1374&scoped=true&ts=true"
import script from "./FileUploadConfig.vue?vue&type=script&lang=ts"
export * from "./FileUploadConfig.vue?vue&type=script&lang=ts"

import "./FileUploadConfig.vue?vue&type=style&index=0&id=5d3a1374&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3a1374"]])

export default __exports__